import React from 'react';
import moment from 'moment';
import API from '../../../utils/API';
import FieldModal from '../../../components/modals/fieldModal';
import InputField from '../../../components/inputs/inputField';
import TimeField from '../../../components/inputs/timeField';

class ScheduleCloseFormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            date: '',
            time: '',
            isDateBefore: false,
            requiredFields: { date: false, time: false }
        };
    }

    scheduleClose = async () => {
        const { date, time } = this.state;
        const { orgId, formId, updateCloseStatus, toggle, isScheduled } = this.props;
        let requiredFields = { ...this.state.requiredFields };
        let valid = true;

        if (isScheduled) {
            this.unscheduleClose();
            return;
        }

        if (!date) { requiredFields.date = true; valid = false; } else { requiredFields.date = false; }
        if (!time) { requiredFields.time = true; valid = false; } else { requiredFields.time = false; }

        if (valid) {
            const selectedDate = new Date(`${date} ${time}`);
            const currentTimeDate = new Date(moment().format('MM/DD/YYYY hh:mm a'));
            if (selectedDate >= currentTimeDate) {
                this.setState({ isDateBefore: false, submitting: true });
                await API()
                    .patch(`Organizations/${orgId}/accountForms/${formId}/close`, { closeAt: selectedDate })
                    .then(() => {
                        this.setState({ submitting: false });
                        updateCloseStatus({ closeAt: selectedDate, closed: false }, toggle);
                    })
                    .catch(() => this.setState({ submitting: false }));
            } else {
                this.setState({ isDateBefore: true });
            }
        } else {
            this.setState({ requiredFields });
        }
    };

    unscheduleClose = async () => {
        const { orgId, formId, updateCloseStatus, toggle } = this.props;
        this.setState({ submitting: true });
        await API()
            .patch(`Organizations/${orgId}/accountForms/${formId}/close`, { closeAt: null })
            .then(() => {
                this.setState({ submitting: false });
                updateCloseStatus({ closeAt: null, closed: false }, toggle);
            })
            .catch(() => this.setState({ submitting: false }));
    };

    render() {
        const { isOpen, toggle, isScheduled } = this.props;
        const { submitting, date, time, requiredFields, isDateBefore } = this.state;
        const fixedStartDate = date ? moment(date).format('YYYY-MM-DD') : '';
        const currentDate = moment().format('YYYY-MM-DD');

        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={isScheduled ? 'Unschedule Close Form' : 'Schedule Close Form'}
                bodyHeaderText={
                    isScheduled
                        ? 'Are you sure you want to remove the scheduled close time?'
                        : 'Schedule your form to be closed at a specific time in the future.'
                }
                bodyContent={() =>
                    !isScheduled ? (
                        <div>
                            <div style={{ display: 'flex', paddingTop: 10 }}>
                                <div>
                                    <InputField
                                        label="Date"
                                        style={{ width: 150 }}
                                        value={fixedStartDate}
                                        required={true}
                                        errorTrigger={requiredFields.date}
                                        type="date"
                                        inputIcon={<i className="lar la-calendar" />}
                                        onChange={(e) =>
                                            this.setState({ date: moment(e.target.value).format('MM/DD/YYYY') })
                                        }
                                        min={currentDate}
                                    />
                                </div>
                                <div className="ml-15">
                                    <TimeField
                                        label="Time"
                                        value={time}
                                        required={true}
                                        errorTrigger={requiredFields.time}
                                        onChange={(val) => this.setState({ time: val })}
                                    />
                                </div>
                            </div>
                            {isDateBefore && (
                                <p className="danger mt-10">Selected date/time must be in the future.</p>
                            )}
                        </div>
                    ) : (
                        <div />
                    )
                }
                toggle={toggle}
                actionButtonLabel={submitting ? 'Submitting...' : 'Submit'}
                cancelButtonLabel="Cancel"
                actionButton={this.scheduleClose}
                submitting={submitting}
                actionButtonDisabled={submitting}
            />
        );
    }
}

export default ScheduleCloseFormModal;
